<template>
    <input
        ref="input"
        autoComplete="off"
        class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-xs placeholder-gray-400 focus:outline-hidden focus:ring-gray-600 focus:border-gray-600 sm:text-sm"
        :class="{ 'border-red-600': hasError }"
        :name="name"
        :value="address"
    >
</template>

<script>
import downArrowSimulator from "@fawmi/vue-google-maps/src/utils/simulateArrowDown.js";
import { bindProps, getPropsValues } from "@fawmi/vue-google-maps/src/utils/bindProps.js";

export default {
    name: "AddressAutoFill",
    props: {
        value: String,
        hasError: Boolean,
        name: {
            default: 'address',
            type: String,
        },
        id: {
            default: 'address',
            type: String,
        },
        postcodeId: {
            default: 'postcode',
            type: String,
        },
        suburbId: {
            default: 'city',
            type: String,
        },
        stateId: {
            default: 'state',
            type: String,
        },
    },
    data() {
        return {
            address: this.value,
            states: [
                'SA',
                'WA',
                'NSW',
                'NT',
                'QLD',
                'VIC',
                'ACT',
                'TAS',
            ],
        }
    },
    mounted() {
        this.$gmapApiPromiseLazy().then(() => {
            if (this.selectFirstOnEnter) {
                downArrowSimulator(this.$refs.input)
            }

            const mappedProps = {
                bounds: {
                    type: Object,
                },
                componentRestrictions: {
                    type: Object,
                    // Do not bind -- must check for undefined
                    // in the property
                    noBind: true,
                },
                types: {
                    type: Array,
                    default: function () {
                        return []
                    },
                },
            }

            /* eslint-disable no-unused-vars */
            const finalOptions = {
                ...getPropsValues(this, mappedProps),
                ...{
                    componentRestrictions: {
                        country: 'au'
                    },
                },
            };

            this.$autocomplete = new google.maps.places.Autocomplete(this.$refs.input, finalOptions)
            bindProps(this, this.$autocomplete, mappedProps)

            this.$watch('componentRestrictions', (v) => {
                if (v !== undefined) {
                    this.$autocomplete.setComponentRestrictions(v)
                }
            })

            // Not using `bindEvents` because we also want
            // to return the result of `getPlace()`
            this.$autocomplete.addListener('place_changed', () => {
                this.changed(this.$autocomplete.getPlace())
            })
        })
    },
    methods: {
        changed(e) {
            if (! e) {
                return;
            }

            let postcode = e.address_components.find((c) => !! c.types.find((t) => t == 'postal_code'));

            if (postcode && this.postcodeId) {
                document.getElementById(this.postcodeId).value = postcode.short_name;
            }

            let locality = e.address_components.find((c) => !! c.types.find((t) => t == 'locality'));

            if (locality && this.suburbId) {
                document.getElementById(this.suburbId).value = locality.long_name;
            }

            let state = e.address_components.find((c) => !! c.types.find((t) => t == 'administrative_area_level_1'));

            if (state && this.states.includes(state.short_name) && this.stateId) {
                document.getElementById(this.stateId).value = state.short_name;
            }

            this.address = e.name;
        },
    }
}
</script>
